import { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useRolesContext } from './RolesContext';
import { ROLE_NAME, INITIAL_PERMISSIONS } from '../constants';

const validateUniqueName = (roleNames: string[]) => (value: string) =>
  !roleNames.includes(value.trim());

const createSchema = (roleNames: string[] = []) =>
  z.object({
    [ROLE_NAME]: z
      .string()
      .trim()
      .min(1, 'Name is required')
      .refine(validateUniqueName(roleNames), { message: 'A role with that name already exists.' }),
    [INITIAL_PERMISSIONS]: z.number().optional(),
  });

const defaultValues = {
  [ROLE_NAME]: '',
  [INITIAL_PERMISSIONS]: undefined,
};

export const NewRoleFormProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { combinedRoles } = useRolesContext();
  const roleNames = combinedRoles.map((role) => role.name);

  const schema = createSchema(roleNames);
  type FormSchemaType = Required<z.infer<typeof schema>>;

  const methods = useForm<FormSchemaType>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
